/* Libraries */
import emitter from "@/emitter";
import controllerTypes from "@/enums/ControllerTypes";

export class Controller {
	get midiConnected() {
		return this._midiConnected;
	}

	set midiConnected(value) {
		this._midiConnected = value;
	}

	get controllerType() {
		return this._controllerType;
	}

	set controllerType(value) {
		this._controllerType = value;
	}

	get channels() {
		return this._channels;
	}

	set channels(value) {
		this._channels = value;
	}

	constructor(ports, channels, midiConnected, controllerType) {
		this.inputPort = ports.inputPort;
		this.outputPort = ports.outputPort;
		this._channels = channels;
		this._midiConnected = midiConnected;
		this._controllerType = controllerType;
		let mapping = null;

		if (controllerType === controllerTypes.Default) {
			mapping = {
				"channel1":
					{
						"screen": {
							"channel": 0,
							"type": "screen"
						},
						"button1": {
							"channel": 0,
							"data1": 66,
							"type": "toggleButton"
						},
						"button2": {
							"channel": 0,
							"data1": 67,
							"type": "toggleButton"
						},
						"button3": {
							"channel": 0,
							"data1": 65,
							"type": "toggleButton"
						},
						"button4": {
							"channel": 0,
							"data1": 64,
							"type": "toggleButton"
						},
						"fader1": {
							"channel": 0,
							"data1": 15,
							"type": "fader"
						},
						"fader1Press": {
							"channel": 0,
							"data1": 74,
							"type": "button"
						}
					},
				"channel2":
					{
						"screen": {
							"channel": 1,
							"type": "screen"
						},
						"button1": {
							"channel": 1,
							"data1": 66,
							"type": "toggleButton"
						},
						"button2": {
							"channel": 1,
							"data1": 67,
							"type": "toggleButton"
						},
						"button3": {
							"channel": 1,
							"data1": 65,
							"type": "toggleButton"
						},
						"button4": {
							"channel": 1,
							"data1": 64,
							"type": "toggleButton"
						},
						"fader1": {
							"channel": 1,
							"data1": 15,
							"type": "fader"
						},
						"fader1Press": {
							"channel": 1,
							"data1": 74,
							"type": "button"
						}
					},
				"channel3":
					{
						"screen": {
							"channel": 2,
							"type": "screen"
						},
						"button1": {
							"channel": 2,
							"data1": 66,
							"type": "toggleButton"
						},
						"button2": {
							"channel": 2,
							"data1": 67,
							"type": "toggleButton"
						},
						"button3": {
							"channel": 2,
							"data1": 65,
							"type": "toggleButton"
						},
						"button4": {
							"channel": 2,
							"data1": 64,
							"type": "toggleButton"
						},
						"fader1": {
							"channel": 2,
							"data1": 15,
							"type": "fader"
						},
						"fader1Press": {
							"channel": 2,
							"data1": 74,
							"type": "button"
						}
					},
				"channel4":
					{
						"screen": {
							"channel": 3,
							"type": "screen"
						},
						"button1": {
							"channel": 3,
							"data1": 66,
							"type": "toggleButton"
						},
						"button2": {
							"channel": 3,
							"data1": 67,
							"type": "toggleButton"
						},
						"button3": {
							"channel": 3,
							"data1": 65,
							"type": "toggleButton"
						},
						"button4": {
							"channel": 3,
							"data1": 64,
							"type": "toggleButton"
						},
						"fader1": {
							"channel": 3,
							"data1": 15,
							"type": "fader"
						},
						"fader1Press": {
							"channel": 3,
							"data1": 74,
							"type": "button"
						}
					}
			};
		}
		else {
			mapping = {
				"channel1":
					{
						"screen": {
							"channel": 0,
							"type": "screen"
						},
						"fader1": {
							"channel": 0,
							"data1": 15,
							"type": "fader"
						}
					},
				"channel2":
					{
						"screen": {
							"channel": 1,
							"type": "screen"
						},
						"fader1": {
							"channel": 1,
							"data1": 15,
							"type": "fader"
						}
					},
				"channel3":
					{
						"screen": {
							"channel": 2,
							"type": "screen"
						},
						"fader1": {
							"channel": 2,
							"data1": 15,
							"type": "fader"
						}
					},
				"channel4":
					{
						"screen": {
							"channel": 3,
							"type": "screen"
						},
						"fader1": {
							"channel": 3,
							"data1": 15,
							"type": "fader"
						}
					},
				"channel5":
					{
						"screen": {
							"channel": 4,
							"type": "screen"
						},
						"fader1": {
							"channel": 4,
							"data1": 15,
							"type": "fader"
						}
					},
				"channel6":
					{
						"screen": {
							"channel": 5,
							"type": "screen"
						},
						"fader1": {
							"channel": 5,
							"data1": 15,
							"type": "fader"
						}
					}
			};
		}

		this.colors = {
			"red": "255,0,0",
			"green": "0,255,0",
			"yellow": "255,255,0",
			"blue": "0,0,255",
			"black": "0,0,0",
			"grey": "0,0,0",
			"white": "255,255,255",
			"pink-lighten-3": "80,0,0",
			"red-lighten-3": "80,0,0",
			"green-lighten-3": "0,100,0",
			"yellow-lighten-3": "50,50,0"
		};
		this.mappings = mapping;

		emitter.on("onSetFader", (evt) => {
			if (this.midiConnected) {
				this.moveFader(
					evt.channel,
					evt.value,
					evt.mode
				)
			}
		});

		emitter.on("onSetButtonColor", (evt) => {
			if (evt.assignedChannel && this.midiConnected) {
				this.setButton(
					evt.assignedChannel,
					evt.button,
					this.colors[evt.color ?? "black"].split(',')[0],
					this.colors[evt.color ?? "black"].split(',')[1],
					this.colors[evt.color ?? "black"].split(',')[2]
				)
			}
		});

		emitter.on("onSetChannelName", (evt) => {
			if (this.midiConnected) {
				this.setText(evt.channel, (evt.channelName ?? "").padStart(10, ' '));
			}
		});

		emitter.off("resetAllChannels", this.resetAllChannels);
		emitter.on("resetAllChannels", this.resetAllChannels);

		this.lastMidiDataString = null;
		this.lastMidiTimestamp = null;
		this.inputPort.onmidimessage = (event) => {
			const dataString = event.data.join(',');

			const isDuplicate = this.lastMidiDataString === dataString &&
								this.lastMidiTimestamp && Math.abs(event.timeStamp - this.lastMidiTimestamp) <= 2;
			if (isDuplicate) {
				return;
			}

			this.lastMidiDataString = dataString;
			this.lastMidiTimestamp = event.timeStamp;

			this.onMIDIMessage(event);
		}
	}

	onMIDIMessage(e) {
		let channel = null;
		let control = null;

		if (e.data[0] === 176 && e.data[2] === 127) {
			if (e.data[1] === 122) {
				emitter.emit("change-mode:pressed");
				return;
			}
			else if (e.data[1] === 123) {
				emitter.emit("midi:setSequencerAction", {action: "PlayNext", msg: {EventID: null}});
				return;
			}
			else if (e.data[1] === 124) {
				emitter.emit("midi:setSequencerAction", {action: "Stop", msg: {EventID: null}});
				return;
			}
		}

		if (e.data[0] === 128) {
			emitter.emit("dump:pressed");
			return;
		}

		for (let mapping in this.mappings) {
			for (let key in this.mappings[mapping]) {
				if (
					e.data[0] === this.mappings[mapping][key].channel + 176 &&
					e.data[1] === this.mappings[mapping][key].data1
				) {
					control = key
					channel = this.channels.findIndex(c => {
						return c.assignment === mapping;
					});
					break
				}
			}
		}
		if (channel == null || control == null || channel < 0) {
			return
		}

		if (control.includes("button") && e.data[2] === 127) {
			emitter.emit("button:pressed", {
				"channel": this.channels[channel].channelNumber,
				"button": control,
				"mode": this.channels[channel].mode,
				"source": "controller"
			});
		}
		else if (control === "fader1") {
			emitter.emit("fader:moved", {
				channel: this.channels[channel].channelNumber,
				mode: this.channels[channel].mode,
				value: e.data[2],
				source: "controller"
			});
		}
		else if (control === "fader1Press") {
			emitter.emit("fader:pressed", {
				channel: this.channels[channel].channelNumber,
				mode: this.channels[channel].mode,
				pressed: e.data[2],
				source: "controller"
			})
		}
	}

	sendMessage(msg) {
		this.outputPort.send(msg);
	}

	setButton(channel, button, red, green, blue) {
		let channelIndex = this.channels.findIndex(c => {
			return c.assignment === channel;
		});

		if (channelIndex > -1) {
			const assignment = this.channels[channelIndex].assignment;
			if (!this.mappings[assignment] || !this.mappings[assignment][button]) {
				return;
			}
			let d = [
				0xF0,                                                 // Running Status
				0x15,                                                 //
				0x40,                                                 //
				this.mappings[assignment][button].channel, // Channel
				this.mappings[assignment][button].data1,   // Data1
				Number(red / 2),                                     // Red
				Number(green / 2),                                   // Green
				Number(blue / 2),                                     // Blue
				0xF7                                                        // End
			];
			this.sendMessage(d);
		}
	}

	setText(channel, text) {
		//todo: check assignment
		if (!this._channels[channel] || this._channels[channel].assignment == null) {
			return;
		}

		this.sendMessage([
				0xF0,
				0x15,
				0x40,
				0x04,
				this.mappings[this._channels[channel].assignment]["screen"].channel,
				0x05,
				0xF7
			]
		);

		if (text.length > 0) {
			let lines = text.split("\n")
			for (let i = 0; i < lines.length; i++) {
				let d = [
					0xF0,                                                 // Running Status
					0x15,                                                 //
					0x40,                                                 //
					0x04,                                                 //
					this.mappings[this._channels[channel].assignment]["screen"].channel, // Channel
					0x03,                                                 //
					i
				]
				for (let y = 0; y < lines[i].length; y++) {
					d.push(lines[i].charCodeAt(y));
				}
				d.push(0xF7)                                                  // End
				this.sendMessage(d);
			}
		}
	}

	moveFader(channel, value, mode) {
		channel = this.channels.findIndex(c => {
			return c.channelNumber === channel && c.mode === mode;
		});

		if (channel > -1 && this.channels[channel].assignment) {
			const assignment = this.channels[channel].assignment;
			if (!this.mappings[assignment] || !this.mappings[assignment]["fader1"]) {
				return;
			}
			let d = [
				this.mappings[assignment]["fader1"].channel + 176,
				this.mappings[assignment]["fader1"].data1,
				value
			];
			this.sendMessage(d);
		}
	}

	resetAllChannels() {
		if (this.midiConnected) {
			this.channels.forEach(channel => {
				if (channel.assignment && this.mappings[channel.assignment]) {
					Object.keys(this.mappings[channel.assignment]).forEach(component => {
						if (component.includes("button")) {
							this.setButton(
								channel.assignment,
								component,
								this.colors["black"],
								this.colors["black"],
								this.colors["black"]
							);
						}
						else if (component.includes("fader")) {
							this.moveFader(
								channel.channelNumber,
								0,
								channel.mode
							);
						}
						else if (component.includes("screen")) {
							this.setText(
								channel.channelNumber,
								""
							);
						}
					});
				}
			});
		}
	}
}